var openpgp = require("openpgp");

export const encrypter = {
    keys: null,
    async init() {
        let decryptedPrivateKeyArmored = localStorage.getItem("ruminote.privateKey");
        let publicKeyArmored = localStorage.getItem("ruminote.publicKey");
        if (decryptedPrivateKeyArmored && publicKeyArmored) {
            const privKeyObj = (
                await openpgp.key.readArmored(decryptedPrivateKeyArmored)
            ).keys[0];
            const publicKeys = (await openpgp.key.readArmored(publicKeyArmored)).keys;
            this.keys = {
                privateKey: privKeyObj,
                publicKey: publicKeys
            };
        }
    },
    check: async function() {
        if (this.keys === null) {
            await this.init();
        }
    },
    encryptText: async function(text) {
        await this.check();
        const options = {
            message: openpgp.message.fromText(text), // input as Message object
            publicKeys: this.keys.publicKey, // for verification (optional)
            privateKeys: [this.keys.privateKey] // for decryption
        };
        const encryptedText = await openpgp.encrypt(options);
        return encryptedText;
    },
    decryptText: async function(encrypted) {
        await this.check();
        console.log('keys', this.keys);
        const options = {
            message: await openpgp.message.readArmored(encrypted), // parse armored message
            publicKeys: this.keys.publicKey, // for verification (optional)
            privateKeys: [this.keys.privateKey] // for decryption
        };
        const decryptedText = await openpgp.decrypt(options);
        return decryptedText;
    },
};